var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMassMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20.0384V3.3077C1.5 2.80257 1.675 2.375 2.025 2.025C2.375 1.675 2.80257 1.5 3.3077 1.5H18.6923C19.1974 1.5 19.625 1.675 19.975 2.025C20.325 2.375 20.5 2.80257 20.5 3.3077V14.6923C20.5 15.1974 20.325 15.625 19.975 15.975C19.625 16.325 19.1974 16.5 18.6923 16.5H5.03845L1.5 20.0384ZM4.4 15H18.6923C18.7692 15 18.8397 14.9679 18.9038 14.9038C18.9679 14.8397 19 14.7692 19 14.6923V3.3077C19 3.23077 18.9679 3.16024 18.9038 3.09613C18.8397 3.03203 18.7692 2.99998 18.6923 2.99998H3.3077C3.23077 2.99998 3.16024 3.03203 3.09613 3.09613C3.03202 3.16024 2.99998 3.23077 2.99998 3.3077V16.3846L4.4 15Z",
    fill: "black",
    fillOpacity: 0.88
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.475 19.4749C23.825 19.1249 24 18.6974 24 18.1922V5.49995H22.5V18.1922C22.5 18.2692 22.4679 18.3397 22.4038 18.4038C22.3397 18.4679 22.2692 18.5 22.1923 18.5H7.53845V19.9999H22.1923C22.6974 19.9999 23.125 19.8249 23.475 19.4749Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassMessage);
export default __webpack_public_path__ + "static/media/MassMessage.4440a4f22c02ba406a6eb234527e9450.svg";
export { ForwardRef as ReactComponent };